
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

interface AdminHeaderProps {
  userEmail?: string;
}

const AdminHeader = ({ userEmail }: AdminHeaderProps) => {
  const { logout } = useAuth();
  const { toast } = useToast();

  const handleLogout = () => {
    logout();
    toast({
      title: "Logged out",
      description: "You have been successfully logged out",
    });
  };

  return (
    <div className="flex justify-between items-center mb-8">
      <div>
        <h1 className="text-2xl font-bold text-redflags-dark">Admin Dashboard</h1>
        <p className="text-redflags-gray">
          Welcome back, {userEmail}
        </p>
      </div>
      
      <div>
        <Button
          variant="outline"
          className="text-redflags-gray hover:text-redflags-dark"
          onClick={handleLogout}
        >
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default AdminHeader;
